import Vue from "vue";
import { datadogRum } from "@datadog/browser-rum";

datadogRum.init(
  process.env.VUE_APP_ENV_NAME == "prd"
    ? {
        applicationId: "5dbc55f4-9724-41dc-87f9-a1b031678aa9",
        clientToken: "pub1acafbb2bfeaa9beb1849cd9032982ae", // gitleaks:allow
        site: "datadoghq.com",
        service: "ktzn-chat-fe-pwa",
        env: "prd",
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        // sampleRate: 100,
        sessionSampleRate: 100,
        trackUserInteractions: true,
      }
    : process.env.VUE_APP_ENV_NAME === "beta"
    ? {
        applicationId: "50688466-e21a-4433-946f-ef1bdb211aa1",
        clientToken: "pubbfbeabbea6f0230df4f2467a482de5b1", // gitleaks:allow
        site: "datadoghq.com",
        service: "ktzn-chat-fe-pwa.beta",
        env: "beta",
        sessionSampleRate: 100,
        trackUserInteractions: true,
      }
    : {
        //stop tracing for any env besides beta, prod
        applicationId: "50688466-e21a-4433-946f-ef1bdb211aa1",
        clientToken: "pubbfbeabbea6f0230df4f2467a482de5b1", // gitleaks:allow
        site: "datadoghq.com",
        service: "ktzn-chat-fe-pwa.beta",
        env: "other",
        sessionSampleRate: 0,
        trackUserInteractions: false,
      }
);
